import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { HString, SharedExternalCMRAgentDriverQRPage } from '@shared/src/public-api';
import { Location } from '@angular/common';
import { SharedExternalCMRAgentPoliceQRComponent } from './shared.external.cmr.agent.police.qr.component';

@Component({
    selector: 'shared-external-cmr-agent-police-qr-page',
    templateUrl: './shared.external.cmr.agent.police.qr.page.html',
    styleUrls: ['../shared.external.cmr.agent.qr.page.scss']
})
export class SharedExternalCMRAgentPoliceQRPage implements OnInit {


    public allLoaded: boolean = false;
    public useIonic: boolean = false;
    constructor(public router: Router, protected activatedRoute: ActivatedRoute,
        public location: Location,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController) {

        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();

        //Fem subscribe per detectar només el location.back i location.forward que s'executen  només al anar endevant i enrera en els botons del navegador
        //Nomes ho fem amb aquests dos casos ja que o sinó esta constantment detectant canvis al canviar els parametres de url en el routeTo
        this.location.subscribe(
            ((value: PopStateEvent) => {
                console.log(value);
                this.loadParametersLocation();
            }),
            (ex => {
                console.log("Error occured postate event")
                console.log(ex);
            })
        );
    }

    
    public showButtonBack: boolean = false;

    public __uuidQR: string;
    public set uuidQR(value: string) {
        if (this.__uuidQR === value)
            return;
        this.__uuidQR = value;
        this.loadTenantId();
    }
    public get uuidQR(): string {
        return this.__uuidQR;
    }
    
    public tenantId: number;
    loadTenantId() {
        if (!HString.isNullOrNullString(this.uuidQR)) {
            this.openRouteCMRController.getTenantIdByUUID(this.uuidQR).subscribe(data => { 
                this.tenantId = data;
            });
        }
    }

    ngOnInit(): void {
    
        this.loadParameters();

        this.router.events.subscribe((event: RouterEvent) => {
            if (event instanceof NavigationEnd) {
                this.loadParametersLocation();
            }
        });

    }

    public loadParameters(){
        this.activatedRoute.params.subscribe(a => {
            this.uuidQR = a.uuidQR;
            this.loadParametersLocation();   
        });
    }
    
    public loadParametersLocation() {

        let path = this.location.path();
        if (path == "")
            return;
    
        let tree = this.router.parseUrl(path);
        let queryParams = tree.queryParams;
    
        let option = queryParams[SharedExternalCMRAgentDriverQRPage.PARAMETEROPTIONNAME];
        if (option)
            this.optionExpanded = option;
                
        this.allLoaded = true;
        
    }
    
    routeTo() {
        if (!this.allLoaded || this.useIonic)
            return;
    
        if (!HString.startsWith(this.router.url, "/external/cmr/qr"))
            return;
    
        let object = { ...this.activatedRoute.snapshot.queryParams };
        if (!HString.isNullOrNullString(this.optionExpanded))
            object[SharedExternalCMRAgentDriverQRPage.PARAMETEROPTIONNAME] = this.optionExpanded;
        else
            delete object[SharedExternalCMRAgentDriverQRPage.PARAMETEROPTIONNAME];
        
        //Aqui no estem rederigint, només estem actualtzant els queryParams perque es vegi reflectida la URL. 
        //Al no redirigir (que ja es el que volem perquè no es necessàri), no està refrescant la pagina i no entrarà pel ngOnInit()
        this.router.navigate([".", {}], { relativeTo: this.activatedRoute, queryParams: object, queryParamsHandling: '' });
    }

    public __optionExpanded: string;
    public set optionExpanded(value: string) {
        if (this.__optionExpanded === value)
            return;
        this.__optionExpanded = value;
        this.welcomeOptionExpanded(this.optionExpanded);
    }
    public get optionExpanded(): string {
        return this.__optionExpanded;
    }

    public onOptionExpandedChanged(option: string){
        this.optionExpanded = option;
    }

    public welcomeOptionExpanded(option: string){
        this.optionExpanded = option;
        this.showButtonBack = !HString.isNullOrNullString(option);
        this.routeTo();
    }
    

    @ViewChild(SharedExternalCMRAgentPoliceQRComponent) policeComponent: SharedExternalCMRAgentPoliceQRComponent;

    onClickBack(){
        this.policeComponent?.collapse();
    }  

    public pretty(value: any): string {
        return JSON.stringify(value);
    }
}
